var map = {
	"./button.md": "ZI7X",
	"./create.md": "1KUt",
	"./deploy.md": "9jCT",
	"./giud.md": "K7yA",
	"./icon.md": "k4Jh",
	"./iconfont.md": "3pvG",
	"./install.md": "0aZB",
	"./md2vue.md": "pAUz",
	"./message.md": "uQgP",
	"./start.md": "cYpM",
	"./theme.md": "aLHV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J8Iv";


//////////////////
// WEBPACK FOOTER
// ./src/docs ^\.\/.*\.md$
// module id = J8Iv
// module chunks = 0